import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Support.css';

const Support = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    whatsapp: '',
    mensagem: ''
  });

  const [messageSent, setMessageSent] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch('https://us-central1-carey-appy.cloudfunctions.net/sendSupportEmail', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        setMessageSent(true);
        setFormData({
          nome: '',
          email: '',
          whatsapp: '',
          mensagem: ''
        });
      } else {
        console.error("Erro ao enviar email:", data.error);
      }
    })
    .catch(error => {
      console.error("Erro ao enviar email:", error);
    });
  };

  return (
    <div className="support-container">
      <h1 className="support-title">Atendimento ao Cliente</h1>
      <p>Horário de atendimento das 9h às 17h</p>
      <div className="support-options">
        <a href="https://wa.me/5511934741617" target="_blank" rel="noopener noreferrer" className="whatsapp-button">
          <i className="fab fa-whatsapp"></i> Atendimento via WhatsApp
        </a>
      </div>
      <p>ou preencha abaixo o formulário de contato</p>
      <form onSubmit={handleSubmit} className="support-form">
        <input
          type="text"
          name="nome"
          placeholder="Nome"
          value={formData.nome}
          onChange={handleInputChange}
          required
          className="support-input"
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleInputChange}
          required
          className="support-input"
        />
        <input
          type="text"
          name="whatsapp"
          placeholder="WhatsApp/Celular"
          value={formData.whatsapp}
          onChange={handleInputChange}
          required
          className="support-input"
        />
        <textarea
          name="mensagem"
          placeholder="Mensagem"
          value={formData.mensagem}
          onChange={handleInputChange}
          required
          className="support-input support-textarea"
        ></textarea>
        <p>Respondemos em até 72 horas.</p>
        <button type="submit" className="support-submit-button">Enviar</button>
      </form>
      {messageSent && (
        <p className="confirmation-message">Recebemos sua mensagem e tão logo entraremos em contato. Equipe Carey.</p>
      )}
      <button onClick={() => navigate('/home')} className="back-home-button">Voltar para Home</button>
    </div>
  );
};

export default Support;

